import React, { useContext, useEffect, useState } from "react";
import FadeIn from "react-fade-in";
import { UserContext } from "../../../storage/contexts/UserContext";
import { getTimeOfDay } from "../../../helpers/TimeOfDay";
import CommonQuestionnaireCard from "../../../InterstellrComponents/CommonQuestionnaireCard";
import axios from "axios";
import { generateURLOptions } from "../../../URLOptions";
import { GET_QUESTIONNAIRES } from "../../../Routes";

const EmployeeQuestionnaires = () => {
  const { profile } = useContext(UserContext);
  const [pending, setPending] = useState([]);
  const [previous, setPrevious] = useState([]);

  useEffect(() => {
    getQuestionnaires();
  }, []);

  const getQuestionnaires = async () => {
    await axios
      .get(GET_QUESTIONNAIRES, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        setPending(response.data?.data?.pending ?? []);
        setPrevious(response.data?.data?.previous ?? []);

        console.log("Questionnaires Response: ", response);
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  return (
    <>
      <div
        className="w-screen h-[90vh]"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <div className="container mx-auto flex flex-col justify-center items-center h-full w-full">
          <div className="w-full md:w-2/3 px-6 md:px-0">
            <FadeIn delay={200}>
              <div className="flex flex-col mb-4">
                <div className="flex flex-col">
                  <h4 className="font-normal text-black text-2xl">
                    {getTimeOfDay()}
                  </h4>

                  <h5 className="font-semibold text-black text-3xl mt-1 mb-4">
                    {profile?.firstname ?? ""} {profile?.lastname ?? ""}
                  </h5>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={350}>
              <div className="flex flex-col w-full">
                <p className="text-slate-500 font-medium mb-1">
                  Pending Questionnaires
                </p>
                {pending?.length > 0 ? (
                  pending?.map((data) => (
                    <CommonQuestionnaireCard key={data?._id} item={data} />
                  ))
                ) : (
                  <div className="bg-white shadow-md flex flex-row items-center p-6 rounded-xl mt-2">
                    <img
                      className="w-8 h-8 object-contain"
                      alt={"Pending Questionnaires"}
                      src={require("../../../assets/images/ic_pending.png")}
                    />
                    <p className="ml-4 text-black font-medium text-base">
                      Your pending questionnaires will appear here
                    </p>
                  </div>
                )}
              </div>

              <div className="flex flex-col w-full mt-8">
                <p className="text-slate-500 font-medium mb-1">
                  Previous Questionnaires
                </p>
                {previous?.length > 0 ? (
                  previous?.map((data) => (
                    <CommonQuestionnaireCard
                      key={data?._id}
                      item={data}
                      completed={true}
                    />
                  ))
                ) : (
                  <div className="bg-white shadow-md flex flex-row items-center p-6 rounded-xl mt-2">
                    <img
                      className="w-8 h-8 object-contain"
                      alt={"Pending Questionnaires"}
                      src={require("../../../assets/images/ic_previous.png")}
                    />
                    <p className="ml-4 text-black font-medium text-base">
                      Your past questionnaires will appear here
                    </p>
                  </div>
                )}
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeQuestionnaires;
